import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import ConfigData from '../../config.json';
import { GolbalDataContext } from '../../components/store/global-data-provider';

const AllTypeRequest = () => {
    const history = useHistory();
    const { changeTitlePage } = useContext(GolbalDataContext);
    const [dataRequestType, setDataRequestType] = useState([]);

    useEffect(() => {
        changeTitlePage("Legal Request System");
        LoadDataRequsetTempType();
    }, []);

    const OnClickSubRequestType = (tableName) => {
        history.push("/request-form/" + btoa(tableName));
    };

    const LoadDataRequsetTempType = () => {
        let url = ConfigData.API_URL + "form-temp/?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            // console.log(respData);
            if(respData.is_sucess === true){
                const dataTable = ConvertDataRequestTypeForTable(respData.data);
                // console.log(dataTable);
                setDataRequestType(dataTable);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    const ConvertDataRequestTypeForTable = (data) => { 
        const grouped = {};
        data.forEach(item => {
            const key = item.id_request_type;
            if (!grouped[key]) {
                grouped[key] = [];
            }
            grouped[key].push(item);
        });
        const result = Object.entries(grouped).map(([key, value]) => ({
            id_request_type: parseInt(key),
            name_en_request_type: value[0].name_en_request_type,
            name_th_request_type: value[0].name_th_request_type,
            data: value
        }));
        return result;
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row className="all-type-request">
                        <Col xl={12}>
                            <Row className="atr-div-header align-items-center">
                                <Col xl={6}>
                                    <div className="atr-div-header-title">
                                        <span className="material-symbols-outlined atr-dht-icon">overview_key</span>
                                        <div className="atr-dht-div-title">
                                            <p className="atr-dht-title">All Type of Request</p>
                                            <p className="atr-dht-subtitle">Which type of request are you looking for?</p>
                                        </div>
                                    </div>
                                    
                                </Col>
                                <Col xl={6}>
                                    <Link to="/create-requests">
                                        <Button type="button" 
                                            color="primary"
                                            className="atr-title-btn-create float-end"
                                        >
                                            <i className="mdi mdi-plus"></i> Create Request
                                        </Button>
                                    </Link>
                                </Col>
                            </Row>
                            {dataRequestType.map((itemRT, indexRT) => {
                                return(
                                    <Row key={"request-type" + indexRT}>
                                        <Col xl={12}>
                                            <p className="atr-title-request-type">{itemRT.name_en_request_type}</p>
                                            <Row>
                                                {itemRT.data.map((itemSRT, indexSRT) => {
                                                return(
                                                    <Col xl={6} key={"sub-request-type" + indexSRT} className="atr-div-sub-request-type">
                                                        <Button id={"btn-sub-request-type-" + indexSRT}
                                                            type="button"
                                                            className="atr-btn-sub-request-type"
                                                            color="primary"
                                                            onClick={() => {
                                                                OnClickSubRequestType(itemSRT.table_name);
                                                            }}
                                                        >
                                                            {/* style={{color: (itemSRT.color !== "") ? itemSRT.color : ""}} */}
                                                            <i className="mdi mdi-book-open-blank-variant atr-icon-sub-request-type" style={{color: (itemSRT.color !== "") ? itemSRT.color : ""}}></i> 
                                                            {(itemSRT.id_sub_request_type > 0) ? itemSRT.name_en_sub_request_type : itemSRT.name_en_request_type}                                                        
                                                        </Button>
                                                    </Col>    
                                                );
                                            })}
                                            </Row>
                                            
                                        </Col>
                                    </Row>
                                );
                            })}
                            <Row>
                                <Col xl={12}>

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default AllTypeRequest;